export enum YesNoNA {
  Yes = 'Yes',
  No = 'No',
  'N/A' = 'N/A'
}
